import { Routes, Route, NavLink } from 'react-router-dom'
import { motion } from 'framer-motion'
import DashboardSessions from './DashboardSessions'
import DashboardBookings from './DashboardBookings'
import DashboardStudents from './DashboardStudents'

const springConfig = { type: "spring", stiffness: 60, damping: 10 }

const managementTabs = [
  { path: 'sessions', label: 'Sessions', icon: '📚' },
  { path: 'bookings', label: 'Bookings', icon: '📅' },
  { path: 'students', label: 'Students', icon: '👥' },
]

export default function DashboardManagement() {

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-semibold text-text-primary mb-2">Management</h2>
        <p className="text-text-primary/70">Manage sessions, bookings, and students</p>
      </div>

      {/* Sub-navigation Tabs */}
      <div className="flex justify-center mb-8">
        <div className="neu p-1.5 rounded-2xl inline-flex gap-2">
          {managementTabs.map((tab) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-semibold text-sm sm:text-base transition-all relative capitalize ${
                  isActive
                    ? 'text-text-primary'
                    : 'text-text-primary/60 hover:text-text-primary'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.div
                      layoutId="activeManagementTab"
                      className="absolute inset-0 bg-accent/10 rounded-xl"
                      transition={springConfig}
                    />
                  )}
                  <span className="text-base sm:text-lg relative z-10">{tab.icon}</span>
                  <span className="relative z-10">{tab.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Content */}
      <Routes>
        <Route path="sessions" element={<DashboardSessions />} />
        <Route path="bookings" element={<DashboardBookings />} />
        <Route path="students" element={<DashboardStudents />} />
        <Route path="*" element={<DashboardSessions />} />
      </Routes>
    </div>
  )
}

